export enum BasicPath {
    HOME = '',
    AUTH = 'auth',
    MAIN = 'main'
}

export enum AuthPath {
    LOGIN = 'login',
    CONFIRM_PASSWORD = 'confirm-password',
    FORGOT_PASSWORD = 'forgot-password',
    NEW_PASSWORD = 'new-password'
}

export enum AppPath {
    SEARCH_BY_ACCOUNT = 'search-by-account',
    UNDERWRITING = 'underwriting',
    INSTALLERS = 'installers',
    CALLS_TO_MAKE = 'calls-to-make',
    SCALED_TICKETS = 'scaled-tickets',
    TICKET = 'ticket',
    TICKET_WITH_ID = 'ticket/:id',
    SCALED_TICKETS_WITH_ID = 'scaled-tickets/:id'
}
